/**
 * useAiSuggestions — стартовые подсказки для пустого AI-чата.
 * Endpoint: GET /api/ai/suggestions
 *
 * Возвращает массив { group, text } — фронт группирует по group.
 */

import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';
import { queryKeys } from './queryKeys';

export interface AiSuggestion {
  group: string;
  text: string;
}

export function useAiSuggestions() {
  return useQuery<AiSuggestion[]>({
    queryKey: queryKeys.ai.suggestions(),
    queryFn: () => apiFetch<AiSuggestion[]>('/api/ai/suggestions'),
    staleTime: 10 * 60_000,
  });
}
